import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const GameCategories = () => {
  const games = [
    {
      id: 1,
      name: 'FIFA Online 4',
      slug: 'fifa-online-4',
      icon: 'ri-football-line',
      color: 'game-fifa',
      image: 'https://public.readdy.ai/ai/img_res/719837afec294ecc54f3eb76b13cb3b8.jpg',
      articles: 156,
      views: '2.3M',
      description: 'Tin tức, hướng dẫn và game thủ FIFA Online 4'
    },
    {
      id: 2,
      name: 'Age of Empires',
      slug: 'age-of-empires',
      icon: 'ri-sword-line',
      color: 'game-aoe',
      image: 'https://readdy.ai/api/search-image?query=age%20of%20empires%20medieval%20strategy%20game%20battle%20scene%2C%20castle%20siege%20with%20armies%2C%20epic%20warfare%2C%20detailed%20rts%20gameplay%20graphics%2C%20historical%20setting&width=600&height=800&seq=game-cat-2&orientation=portrait',
      articles: 203,
      views: '3.1M',
      description: 'AOE 1, AOE 2, giải đấu và game thủ huyền thoại'
    },
    {
      id: 3,
      name: 'Liên Minh Huyền Thoại',
      slug: 'lien-minh-huyen-thoai',
      icon: 'ri-shield-star-line',
      color: 'game-lol',
      image: 'https://readdy.ai/api/search-image?query=league%20of%20legends%20moba%20game%20epic%20team%20fight%2C%20colorful%20champions%20casting%20abilities%2C%20fantasy%20battlefield%2C%20dramatic%20action%20scene%2C%20vibrant%20game%20graphics&width=1000&height=600&seq=game-cat-3&orientation=landscape',
      articles: 342,
      views: '5.7M',
      description: 'Meta, champion, pro players và VCS',
      isWide: true
    },
    {
      id: 4,
      name: 'CS:GO',
      slug: 'csgo',
      icon: 'ri-crosshair-line',
      color: 'game-csgo',
      image: 'https://readdy.ai/api/search-image?query=csgo%20counter%20strike%20tactical%20shooter%20gameplay%2C%20first%20person%20view%20aiming%20weapon%2C%20competitive%20match%20scene%2C%20intense%20action%20moment%2C%20professional%20gaming%20graphics&width=600&height=400&seq=game-cat-4&orientation=landscape',
      articles: 187,
      views: '2.8M',
      description: 'Cập nhật, skin, team và hướng dẫn'
    },
    {
      id: 5,
      name: 'PUBG',
      slug: 'pubg',
      icon: 'ri-crosshair-2-line',
      color: 'game-pubg',
      image: 'https://readdy.ai/api/search-image?query=pubg%20battlegrounds%20battle%20royale%20action%2C%20player%20in%20combat%20with%20weapon%2C%20intense%20firefight%20scene%2C%20dramatic%20battlefield%20environment%2C%20high%20quality%20game%20graphics&width=600&height=400&seq=game-cat-5&orientation=landscape',
      articles: 219,
      views: '4.2M',
      description: 'Tips, map, streamer và giải đấu'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-dark-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-exo font-black text-3xl sm:text-4xl lg:text-5xl text-white mb-3 sm:mb-4"
          >
            DANH MỤC <span className="bg-gradient-gaming bg-clip-text text-transparent">GAME</span>
          </motion.h2>
          <p className="text-gray-400 text-sm sm:text-base lg:text-lg">
            Khám phá tin tức và hướng dẫn về các game phổ biến nhất
          </p>
        </div>

        {/* Games Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {games.map((game, index) => (
            <motion.div
              key={game.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`group relative overflow-hidden rounded-xl sm:rounded-2xl ${
                game.isWide ? 'sm:col-span-2' : ''
              }`}
            >
              <Link to={`/${game.slug}`} className="block">
                {/* Image Container */}
                <div className={`relative ${game.isWide ? 'h-64 sm:h-80 lg:h-96' : 'h-80 sm:h-96 lg:h-[500px]'} overflow-hidden`}>
                  <img
                    src={game.image}
                    alt={game.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-bg via-dark-bg/60 to-transparent"></div>
                  
                  {/* Border Glow on Hover */}
                  <div className={`absolute inset-0 border-2 border-${game.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl sm:rounded-2xl`}></div>
                </div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5 lg:p-6">
                  {/* Icon */}
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-${game.color}/20 border border-${game.color} rounded-lg sm:rounded-xl mb-3 sm:mb-4`}>
                    <i className={`${game.icon} text-xl sm:text-2xl text-${game.color}`}></i>
                  </div>

                  {/* Title */}
                  <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mb-2 group-hover:text-accent-cyan transition-colors">
                    {game.name}
                  </h3>

                  {/* Stats */}
                  <div className="flex items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-400 mb-2 sm:mb-3">
                    <span>{game.articles} bài viết</span>
                    <span>•</span>
                    <span>{game.views} lượt xem</span>
                  </div>

                  {/* Description - Show on Hover */}
                  <p className="text-gray-300 text-xs sm:text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-2 group-hover:translate-y-0">
                    {game.description}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GameCategories;
